// action menus.
import { $$, closeLayer, openLayer, play } from './core.ts';

/** The open menu and the button that opened it. */
interface OpenMenu {
  m: HTMLElement;
  b: HTMLElement;
}

export function initMenus(): void {
  let cur: OpenMenu | null = null;
  const close = (): void => {
    if (!cur) return;
    cur.m.hidden = true;
    cur.b.setAttribute('aria-expanded', 'false');
    closeLayer(close);
    cur = null;
  };
  document.addEventListener('click', e => {
    const b = (e.target as Element).closest<HTMLElement>('[data-ds-menu]');
    if (b) {
      e.preventDefault();
      const m = document.getElementById(b.dataset.dsMenu!);
      if (!m) return;
      if (cur?.m === m) {
        close();
        return;
      }
      close();
      openLayer(close);
      m.hidden = false;
      b.setAttribute('aria-expanded', 'true');
      cur = { m, b };
      $$('.ds-ico', m).forEach(play);
      m.querySelector<HTMLElement>('a,button')?.focus();
      return;
    }
    if (cur && (e.target as Element).closest('.ds-menu .ds-mi')) setTimeout(close);
  });
  document.addEventListener(
    'pointerdown',
    e => {
      if (cur && !cur.m.contains(e.target as Node) && !cur.b.contains(e.target as Node)) close();
    },
    true,
  );
}
